import { GlButton, GlTabs, GlTab, GlLink, GlBadge } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import Markdown from '../../vue_shared/components/markdown/non_gfm_markdown.vue?vue3';
import DocLine from './doc_line.vue';
export default {
    name: 'CodeNavigationPopover',
    components: {
        GlButton,
        GlTabs,
        GlTab,
        GlLink,
        GlBadge,
        DocLine,
        Markdown
    },
    props: {
        position: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        definitionPathPrefix: {
            type: String,
            required: true
        },
        blobPath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            offsetLeft: 0
        };
    },
    computed: {
        isCurrentDefinition () {
            return this.data.definitionLineNumber - 1 === this.position.lineIndex;
        },
        positionStyles () {
            return {
                left: `${this.position.x - this.offsetLeft}px`,
                top: `${this.position.y + this.position.height}px`
            };
        },
        definitionPath () {
            if (!this.data.definition_path) {
                return null;
            }
            if (this.isDefinitionCurrentBlob) {
                return `#L${this.data.definitionLineNumber}`;
            }
            return `${this.definitionPathPrefix}/${this.data.definition_path}`;
        },
        isDefinitionCurrentBlob () {
            return this.data.definition_path.indexOf(this.blobPath) === 0;
        },
        references () {
            return this.data.references || [];
        }
    },
    watch: {
        position: {
            handler () {
                this.$nextTick(()=>this.updateOffsetLeft());
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        updateOffsetLeft () {
            this.offsetLeft = Math.max(0, this.$el.offsetLeft + this.$el.offsetWidth - window.innerWidth + 20);
        }
    }
};
